//监听选项卡的点击事件
      jQuery(".bf-original .tab-item-two").click(function() {
        //先将所有选项卡都恢复到未点击的样式
        jQuery(".bf-original").hide();
        jQuery(".bf-click").show();
        //改变点击的li标签的样式
        jQuery(this).addClass("selected");
        //获取当前点击li标签的索引
        var jQueryindex = jQuery(this).index();
        //根据索引找到对应的内容
        var jQuerycontent = jQuery(".hu-featured-collections .slider-mobile-gutter").eq(jQueryindex)
        //先将所有选项卡内容都隐藏
        jQuery(".hu-featured-collections .slider-mobile-gutter").removeClass("show");
        //展示所点击选项的内容
        jQuerycontent.addClass("show");
      });

      jQuery(".bf-click .tab-item-one").click(function() {
        //先将所有选项卡都恢复到未点击的样式
        jQuery(".bf-click").hide();
        jQuery(".bf-original").show();
        //改变点击的li标签的样式
        jQuery(this).addClass("selected");
        //获取当前点击li标签的索引
        var jQueryindex = jQuery(this).index();
        //根据索引找到对应的内容
        var jQuerycontent = jQuery(".hu-featured-collections .slider-mobile-gutter").eq(jQueryindex)
        //先将所有选项卡内容都隐藏
        jQuery(".hu-featured-collections .slider-mobile-gutter").removeClass("show");
        //展示所点击选项的内容
        jQuerycontent.addClass("show");
      });
/* shouye daojishi js */
window.timeZoneParams = -7;
    /* getLocalTime:时区换算*/
    window.getLocalTime = function (i) {
        // 参数i为时区值数字，比如北京为东八区则输进8,西5输入-5
        if (typeof i !== 'number') return;
        var d = new Date();
        //得到1970年一月一日到现在的秒数
        var len = d.getTime();
        //本地时间与GMT时间的时间偏移差
        var offset = d.getTimezoneOffset() * 60000;
        //得到现在的格林尼治时间
        var utcTime = len + offset;
        return new Date(utcTime + 3600000 * i);
    }
    /*end getLocalTime:时区换算*/
    window.getNextDate = function(date, day) {
        var dd = new Date(date);
        dd.setDate(dd.getDate() + day);
        var y = dd.getFullYear();
        var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
        var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
        return y + "/" + m + "/" + d;
    }


    $(function () {
        if ($(".memberFlash-timeBox").length) {
            var date = getLocalTime(timeZoneParams);
            var date_day = date.getDate();
            var date_month = date.getMonth() + 1;
            var date_year = date.getFullYear();
            var endTime = getNextDate(date_year + "/" + date_month + "/" + date_day, 1);
            var endAllTime = new Date(endTime).getTime() - date;
            function timerMember(intDiff) {
                var hour = 0,
                    minute = 0,
                    second = 0; 
                intDiff = intDiff - 0;
                if (intDiff > 0) {
                    hour = Math.floor(intDiff / 1000 / 60 / 60);
                    minute = Math.floor((intDiff / 1000 / 60) % 60);
                    second = Math.floor((intDiff / 1000) % 60);
                }
                var hourInt =  parseInt(hour / 10);
                hourInt == 2 ? (int1 = 0) : (int1 = hourInt + 1);
                var hourDot = hour % 10;
                hourDot == 9 ? (int2 = 0) : (int2 = hourDot + 1);
              // console.log(hourInt)
                if (!$(".hl .item").eq(hourInt).hasClass("active")) {
                    $(".hl .item.before").removeClass("before");
                    $(".hl .item").eq(int1).addClass("before");
                    $(".hl .item.active").removeClass("active");
                    $(".hl .item").eq(hourInt).addClass("active");

                }

                if (!$(".hr .item").eq(hourDot).hasClass("active")) {
                    $(".hr .item.before").removeClass("before");
                    $(".hr .item").eq(int2).addClass("before");
                    $(".hr .item.active").removeClass("active");
                    $(".hr .item").eq(hourDot).addClass("active");
                }

                var minuteInt =  parseInt(minute / 10);
                minuteInt == 5 ? (int3 = 0) : (int3 = minuteInt + 1);
                var minuteDot = minute % 10;
                minuteDot == 9 ? (int4 = 0) : (int4 = minuteDot + 1);
                if (!$(".ml .item").eq(minuteInt).hasClass("active")) {
                    $(".ml .item.active").removeClass("active");
                    $(".ml .item").eq(minuteInt).addClass("active");
                    $(".ml .item.before").removeClass("before");
                    $(".ml .item").eq(int3).addClass("before");
                }

                if (!$(".mr .item").eq(minuteDot).hasClass("active")) {
                    $(".mr .item.active").removeClass("active");
                    $(".mr .item").eq(minuteDot).addClass("active");
                    $(".mr .item.before").removeClass("before");
                    $(".mr .item").eq(int4).addClass("before");
                }



                var secondInt =  parseInt(second / 10);
                secondInt == 5 ? (int5 = 0) : (int5 = secondInt + 1);
                var secondDot = second % 10;
                secondDot == 9 ? (int6 = 0) : (int6 = secondDot + 1);
                if (!$(".sl .item").eq(secondInt).hasClass("active")) {
                    $(".sl .item.active").removeClass("active");
                    $(".sl .item").eq(secondInt).addClass("active");
                    $(".sl .item.before").removeClass("before");
                    $(".sl .item").eq(int5).addClass("before");
                }

                if (!$(".sr .item").eq(secondDot).hasClass("active")) {
                    $(".sr .item.active").removeClass("active");
                    $(".sr .item").eq(secondDot).addClass("active");
                    $(".sr .item.before").removeClass("before");
                    $(".sr .item").eq(int6).addClass("before");
                }
            }


            function timerMember2(intDiff) {
                var hour = 0,
                    minute = 0,
                    second = 0; 
                intDiff = intDiff - 0;
                if (intDiff > 0) {
                    hour = Math.floor(intDiff / 1000 / 60 / 60);
                    minute = Math.floor((intDiff / 1000 / 60) % 60);
                    second = Math.floor((intDiff / 1000) % 60);
                }
                var hourInt =  parseInt(hour / 10);
              
                hourInt == 2 ? (int1 = 0) : (int1 = hourInt + 1);
                var hourDot = hour % 10;
                hourDot == 9 ? (int2 = 0) : (int2 = hourDot + 1);
              // console.log(hourInt)
                if (!$(".bf-hl .item").eq(hourInt).hasClass("active")) {
                    $(".bf-hl .item.before").removeClass("before");
                    $(".bf-hl .item").eq(int1).addClass("before");
                    $(".bf-hl .item.active").removeClass("active");
                    $(".bf-hl .item").eq(hourInt).addClass("active");

                }

                if (!$(".bf-hr .item").eq(hourDot).hasClass("active")) {
                    $(".bf-hr .item.before").removeClass("before");
                    $(".bf-hr .item").eq(int2).addClass("before");
                    $(".bf-hr .item.active").removeClass("active");
                    $(".bf-hr .item").eq(hourDot).addClass("active");
                }

                var minuteInt =  parseInt(minute / 10);
                minuteInt == 5 ? (int3 = 0) : (int3 = minuteInt + 1);
                var minuteDot = minute % 10;
                minuteDot == 9 ? (int4 = 0) : (int4 = minuteDot + 1);
                if (!$(".bf-ml .item").eq(minuteInt).hasClass("active")) {
                    $(".bf-ml .item.active").removeClass("active");
                    $(".bf-ml .item").eq(minuteInt).addClass("active");
                    $(".bf-ml .item.before").removeClass("before");
                    $(".bf-ml .item").eq(int3).addClass("before");
                }

                if (!$(".bf-mr .item").eq(minuteDot).hasClass("active")) {
                    $(".bf-mr .item.active").removeClass("active");
                    $(".bf-mr .item").eq(minuteDot).addClass("active");
                    $(".bf-mr .item.before").removeClass("before");
                    $(".bf-mr .item").eq(int4).addClass("before");
                }



                var secondInt =  parseInt(second / 10);
                secondInt == 5 ? (int5 = 0) : (int5 = secondInt + 1);
                var secondDot = second % 10;
                secondDot == 9 ? (int6 = 0) : (int6 = secondDot + 1);
                if (!$(".bf-sl .item").eq(secondInt).hasClass("active")) {
                    $(".bf-sl .item.active").removeClass("active");
                    $(".bf-sl .item").eq(secondInt).addClass("active");
                    $(".bf-sl .item.before").removeClass("before");
                    $(".bf-sl .item").eq(int5).addClass("before");
                }

                if (!$(".bf-sr .item").eq(secondDot).hasClass("active")) {
                    $(".bf-sr .item.active").removeClass("active");
                    $(".bf-sr .item").eq(secondDot).addClass("active");
                    $(".bf-sr .item.before").removeClass("before");
                    $(".bf-sr .item").eq(int6).addClass("before");
                }
            }


				
			function timerMember3(intDiff) {
                var hour = 0,
                    minute = 0,
                    second = 0; 
                intDiff = intDiff - 0;
                if (intDiff > 0) {
                    hour = Math.floor(intDiff / 1000 / 60 / 60);
                    minute = Math.floor((intDiff / 1000 / 60) % 60);
                    second = Math.floor((intDiff / 1000) % 60);
                }
                var hourInt =  parseInt(hour / 10);
              
                hourInt == 2 ? (int1 = 0) : (int1 = hourInt + 1);
                var hourDot = hour % 10;
                hourDot == 9 ? (int2 = 0) : (int2 = hourDot + 1);
              // console.log(hourInt)
                if (!$(".me-hl .item").eq(hourInt).hasClass("active")) {
                    $(".me-hl .item.before").removeClass("before");
                    $(".me-hl .item").eq(int1).addClass("before");
                    $(".me-hl .item.active").removeClass("active");
                    $(".me-hl .item").eq(hourInt).addClass("active");

                }

                if (!$(".me-hr .item").eq(hourDot).hasClass("active")) {
                    $(".me-hr .item.before").removeClass("before");
                    $(".me-hr .item").eq(int2).addClass("before");
                    $(".me-hr .item.active").removeClass("active");
                    $(".me-hr .item").eq(hourDot).addClass("active");
                }

                var minuteInt =  parseInt(minute / 10);
                minuteInt == 5 ? (int3 = 0) : (int3 = minuteInt + 1);
                var minuteDot = minute % 10;
                minuteDot == 9 ? (int4 = 0) : (int4 = minuteDot + 1);
                if (!$(".me-ml .item").eq(minuteInt).hasClass("active")) {
                    $(".me-ml .item.active").removeClass("active");
                    $(".me-ml .item").eq(minuteInt).addClass("active");
                    $(".me-ml .item.before").removeClass("before");
                    $(".me-ml .item").eq(int3).addClass("before");
                }

                if (!$(".me-mr .item").eq(minuteDot).hasClass("active")) {
                    $(".me-mr .item.active").removeClass("active");
                    $(".me-mr .item").eq(minuteDot).addClass("active");
                    $(".me-mr .item.before").removeClass("before");
                    $(".me-mr .item").eq(int4).addClass("before");
                }



                var secondInt =  parseInt(second / 10);
                secondInt == 5 ? (int5 = 0) : (int5 = secondInt + 1);
                var secondDot = second % 10;
                secondDot == 9 ? (int6 = 0) : (int6 = secondDot + 1);
                if (!$(".me-sl .item").eq(secondInt).hasClass("active")) {
                    $(".me-sl .item.active").removeClass("active");
                    $(".me-sl .item").eq(secondInt).addClass("active");
                    $(".me-sl .item.before").removeClass("before");
                    $(".me-sl .item").eq(int5).addClass("before");
                }

                if (!$(".me-sr .item").eq(secondDot).hasClass("active")) {
                    $(".me-sr .item.active").removeClass("active");
                    $(".me-sr .item").eq(secondDot).addClass("active");
                    $(".me-sr .item.before").removeClass("before");
                    $(".me-sr .item").eq(int6).addClass("before");
                }
            }


              var groupTime = setInterval(function () {
                if (endAllTime > 0) {
                    timerMember(endAllTime);
                    timerMember2(endAllTime);
                    timerMember3(endAllTime);
                    endAllTime -= 1000;
                } else {
                    date = getLocalTime(timeZoneParams);
                    date_day = date.getDate();
                    date_month = date.getMonth() + 1;
                    date_year = date.getFullYear();
                    endTime = getNextDate(date_year + "/" + date_month + "/" + date_day,1);
                    endAllTime = new Date(endTime).getTime() - date;
                    if (typeof every_flash_enable != "undefined" && every_flash_enable == '1') {
                        homeFlash();
                    }
                }

            
            }, 1000);
        }
    })

// 新版倒计时
    function getLocalTime(i) {
        if (typeof i !== 'number') return;
        var d = new Date();
        var len = d.getTime();
        var offset = d.getTimezoneOffset() * 60000;
        var utcTime = len + offset;
        return new Date(utcTime + 3600000 * i);
    }

    window.getNextDate = function(date, day) {
        var dd = new Date(date);
        // console.log(dd)
        dd.setDate(dd.getDate() + day);
        var y = dd.getFullYear();
        var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
        var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
        return y + "/" + m + "/" + d;
    }
    var timeZoneParams = -8;
    jQuery(function() {
        if (jQuery('.endsIn').length || jQuery('.memberFlash-timeBox').length) {
            var date = getLocalTime(timeZoneParams);
            var date_day = date.getDate();
            var date_month = date.getMonth() + 1;
            var date_year = date.getFullYear();
            var endTime = getNextDate(date_year + '/' + date_month + '/' + date_day, 1);
            var endAllTime = new Date(endTime).getTime() - date;

            function timerMember(intDiff) {
                var hour = 0,
                    minute = 0,
                    second = 0;
                intDiff = intDiff - 0;
                if (intDiff > 0) {
                    hour = Math.floor(intDiff / 1000 / 60 / 60);
                    minute = Math.floor(intDiff / 1000 / 60 % 60);
                    second = Math.floor(intDiff / 1000 % 60);
                }
                if (hour < 10) {
                    hour = '0' + hour;
                }
                if (minute < 10) {
                    minute = '0' + minute;
                }
                if (second < 10) {
                    second = '0' + second;
                }

                jQuery('.flashSale-clock_timeH').text(hour);
                jQuery('.flashSale-clock_timeM').text(minute);
                jQuery('.flashSale-clock_timeS').text(second);
                // 时
                var str1 = hour + '';
                var s1 = str1.substr(0, 1);
                jQuery('.memberFlash-time_timeH_one').text(s1);
                jQuery('.memberFlash-time_timeH_two').text(str1.charAt(str1.length-1));
                // 分
                var str2=minute + '';
                var s2=str2.substr(0, 1);
                jQuery('.memberFlash-time_timeM_one').text(s2);
                jQuery('.memberFlash-time_timeM_two').text(str2.charAt(str2.length-1));
                // 秒
                var str3=second + '';
                var s3=str3.substr(0, 1);
                jQuery('.memberFlash-time_timeS_one').text(s3);
                jQuery('.memberFlash-time_timeS_two').text(str3.charAt(str3.length-1));
            }
            var groupTime = setInterval(function() {
                if (endAllTime > 0) {
                    timerMember(endAllTime);
                    endAllTime -= 1000;
                } else {
                    date = getLocalTime(timeZoneParams);
                    date_day = date.getDate();
                    date_month = date.getMonth();
                    date_year = date.getFullYear();
                    endTime = getNextDate(date_year + '/' + date_month + '/' + date_day);
                    endAllTime = new Date(endTime).getTime() - date;
                }
            }, 1000);
        }

    })
    // 倒计时结束

// by jack edit-20231116
 var GAiiv = function isInView(o) {
          typeof o[0] === 'undefined' ? o = o : o = o[0];
          if (o instanceof HTMLElement) {
              var vph = window.innerHeight, wpw = window.innerWidth;
              var oRect = o.getBoundingClientRect();
              var ott = oRect.top + oRect.height * 0.5;
              var otl = oRect.left + oRect.width * 0.5;
              return (ott > 0 && ott < vph && otl > 0 && otl < wpw);
          } else { return false; }
 }
      var GAgdb = function gaDebounce(fn, wait) {
          var timeout = null;
          return function () {
              if (timeout !== null) { clearTimeout(timeout); }
              timeout = setTimeout(fn, wait);
          }
 }
  function sendLocalProinfo(promitionid,promoname){
      var ga_prInfo=localStorage.getItem("ga_prInfo");
      if(ga_prInfo){
          localStorage.removeItem("ga_prInfo");
      }
            localStorage.setItem('ga_prInfo',JSON.stringify({
                    ts: Date.now()+3600*24*30*1000,
                    promotion_id: promitionid, 
                    promotion_name: promoname
                    }));
}
var tswiperflag = {};
var mymobSwipers = new Swiper('#bfmobSwiper', {
  direction: 'horizontal',
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    clickable:true,
  }, 
  loop: true,
  autoplay: {
		delay: 5000,
		disableOnInteraction: false,
  },
  on:{
    slideChangeTransitionEnd:function(event){
        var mobswiperCon = document.getElementById("bfmobSwiper");
        if(GAiiv(mobswiperCon)){
         var img_index = this.realIndex;
          var mobelection = "#swiperga-push-mob .slide-content-m";
          // var eventType = "dle_view_promotion";
          if(tswiperflag[img_index] !== img_index){
            // console.log("hello*****"+img_index);
                       $(mobelection).eq(img_index).each(function(){
                           var imgitems=new Array();
                           var csl=img_index;
                          var iid = "pageBFsale_swiper-slide02-banner_image";
                          var pid = "pageBFsale_swiper-slide02-banner_image";
                           var cnm = $(this).find("img").attr("src");
                            var pnm = $(this).find("img").attr("alt");
                          imgitems.push({
                               "item_id": iid,
                               "item_name": pnm,
                               "promotion_id": pid,
                               "promotion_name": pnm,
                               "creative_name": cnm,
                               "creative_slot": csl
                            });
                        // if(imgitems.length>0){
                        //      console.log({
                        //          "event":  eventtype,
                        //          "ecommerce":  {
                        //              "items": imgitems
                        //          }
                        //      });
                        //  };
                       if(imgitems.length>0){
                          dataLayer.push({ ecommerce: null });
                          dataLayer.push({
                            "event": "dle_view_promotion",
                            "ecommerce": {
                              "items": imgitems
                          }
                        });
                      };
                  })
            tswiperflag[img_index] = img_index;
          }    
      }
    }
  }
})

var hermosa_tit = new Swiper('.hermosa_tit', {
             slidesPerView:4,
             spaceBetween: 15,
            edgeSlideGap: 20,
             allowSlideNext: false,
             allowSlidePrev: false,
              breakpoints: { 
      		 768: {
                allowSlideNext: true,
                allowSlidePrev: true,
      			slidesPerView:2.5,
      			spaceBetween: 15,
      			},
        	}
        });

var mySwiper2 = new Swiper('.hu-featured-flash', {
            slidesPerView : 4,
            // loop: true,
            // spaceBetween : 15,
             navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            breakpoints: {
              768: {
            slidesPerView:2.3,
            loop: false,
            // spaceBetween: 15,
              },
            },
           scrollbar: {
              el: ".hu-featured-flash .swiper-scrollbar",
           },
        });

// Only Mobile Swiper
    $("#bfmobSwiper .swiper-slide").click(function(){
      var indexReal = mymobSwipers.realIndex;
      var mobSelection = "#swiperga-push-mob .slide-content-m";
      // var eventType = "dle_select_promotion";
      var promotionid ="pageBFsale_swiper-slide02-banner_image";
      var promoname ="";
      $(mobSelection).eq(indexReal).each(function(){
       var promoname = $(this).find("img").attr("alt");
     });
    //  if(promoname == "" || promoname == null){
    //   promoname = "Swiper Slide IMG"+indexReal;
    // }
    promoname =  $(mobSelection).eq(indexReal).find("img").attr("alt");
     if(promoname == "" || promoname == null){
       promoname = "Swiper Slide IMG"+indexReal;
    }
    sendLocalProinfo(promotionid,promoname);
      //send ga4 data
        $(mobSelection).eq(indexReal).each(function(){
                           var imgitems=new Array();
                           var csl=indexReal;
                            var iid = "pageBFsale_swiper-slide02-banner_image";
                            var pid = "pageBFsale_swiper-slide02-banner_image";
                           var cnm = $(this).find("img").attr("src");
                            var pnm = $(this).find("img").attr("alt");
                          imgitems.push({
                               "item_id": iid,
                               "item_name": pnm,
                               "promotion_id": pid,
                               "promotion_name": pnm,
                               "creative_name": cnm,
                               "creative_slot": csl
                            });
                        // if(imgitems.length>0){
                        //      console.log({
                        //          "event":  eventtype,
                        //          "ecommerce":  {
                        //              "items": imgitems
                        //          }
                        //      });
                        //  };
                       if(imgitems.length>0){
                          dataLayer.push({ ecommerce: null });
                          dataLayer.push({
                            "event": "dle_select_promotion",
                            "ecommerce": {
                              "items": imgitems
                          }
                        });
                      };
                  })
    
  })

// jQuery("#Slide-7a882141-ae6a-499c-81d3-ae50b3461dbb-1").click(function () {
//                 jQuery('.home_tanchuang1').removeClass("hu_none");
//                 jQuery('.window-cover').show();
//           });
//       jQuery("#Slide-7a882141-ae6a-499c-81d3-ae50b3461dbb-2").click(function () {
//                 jQuery('.home_tanchuang2').removeClass("hu_none");
//                 jQuery('.window-cover').show();
//           });
//       jQuery("#Slide-7a882141-ae6a-499c-81d3-ae50b3461dbb-3").click(function () {
//                 jQuery('.home_tanchuang3').removeClass("hu_none");
//                 jQuery('.window-cover').show();
//           });
//   jQuery("#Slide-7a882141-ae6a-499c-81d3-ae50b3461dbb-4").click(function () {
//                 jQuery('.home_tanchuang3').removeClass("hu_none");
//                 jQuery('.window-cover').show();
//           });
       jQuery(".pc_home_tanchuang").click(function () {
        jQuery('.home_tanchuang1').addClass("hu_none");
        jQuery('.home_tanchuang2').addClass("hu_none");
        jQuery('.home_tanchuang3').addClass("hu_none");
        jQuery('.home_tanchuang4').addClass("hu_none");
        jQuery('.home_tanchuang5').addClass("hu_none");
        jQuery('.window-cover').hide();
          });

// fenqi
function openPopup(e) {
      	if( e == "paypal" ){
          jQuery('.pc_home_tanchuang-paypal').removeClass("hu_none");
                jQuery('.window-cover').show();
        }
        if( e == "afterpay" ){
            jQuery('.pc_home_tanchuang-afterpay').removeClass("hu_none");
                jQuery('.window-cover').show();
          }
        if( e == "klarna" ){
          jQuery('.pc_home_tanchuang-klarna').removeClass("hu_none");
                jQuery('.window-cover').show();
        }
    }


function closePopup(e) {
      	if( e == "paypal" ){
          jQuery('.pc_home_tanchuang-paypal').addClass("hu_none");
        jQuery('.window-cover').hide();
        }
        if( e == "afterpay" ){
            jQuery('.pc_home_tanchuang-afterpay').addClass("hu_none");
        jQuery('.window-cover').hide();
          }
        if( e == "klarna" ){
          jQuery('.pc_home_tanchuang-klarna').addClass("hu_none");
        jQuery('.window-cover').hide();
        }
        if( e == "tiktok" ){
          jQuery('.pc_home_tanchuang-tiktok').addClass("hu_none");
        jQuery('.window-cover').hide();
        }
    }

// 绑定购物车加减事件
$(function() {
            $(".js-qty__wrapper-hx .js-qty__adjust--plus").click(function() {
                var  qty = $(this).siblings(".js-qty__num").val();
                qty++;
                $(this).siblings(".js-qty__num").val(qty);
            });
            $(".js-qty__wrapper-hx .js-qty__adjust--minus").click(function() {
                var  qty = $(this).siblings(".js-qty__num").val();
                if (qty == 0) {
                    return false;
                }
                qty--;
               $(this).siblings(".js-qty__num").val(qty);
            });
        });
// 判断链接弹窗
function getUrlParam(name) {           
     var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");             
     var r = window.location.search.substr(1).match(reg);        
     if (r != null) { 
        return unescape(r[2]); 
    } 
    return null;
}
// if(getUrlParam("utm_source")){
//   if(getUrlParam("utm_source").indexOf('Tiktok')!= -1 || getUrlParam("utm_source").indexOf('tiktok') != -1 ){
//     jQuery('.pc_home_tanchuang-tiktok').removeClass("hu_none");
//     jQuery('.window-cover').show();
//   }
// }
// copy代码
function copyToClipboard(str) {
      let el = document.createElement("textarea");
      el.value = str;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      let selected =
              document.getSelection().rangeCount > 0
                      ? document.getSelection().getRangeAt(0)
                      : false;
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
    }
    function copyCode(e) {
      let $this = e.target;
      var urlpage = window.location.href;
      var eventcategory= "Product_Code_Page";
      let urldata= $this.getAttribute("data-url");
      if(urlpage.includes('/products')){
        if($.isEmptyObject(urldata)){
          eventcategory = eventcategory;
        }else{
          if(urldata.length ===0 || urldata.trim() === ''){
            eventcategory = eventcategory;
          }else{
            eventcategory = urldata;
          }
        }  
      }
      let codedata= $this.getAttribute("data-code");
      var indexnum = jQuery(e.target).parent().index('.ccfa-i');
      indexnum=indexnum+1;
      var indexpos = "0"+indexnum+"_"+codedata;
      // console.log("hello_"+indexpos);
      // Send ga4 click event
      dataLayer.push({	        
          "event_category": eventcategory,
          "event_action": "copy_click",
          "event_label": indexpos,
	        "event": "cme_copy_code"
    	});
      copyToClipboard($this.getAttribute("data-code"));
      $this.innerText = "copied!";
      setTimeout(function () {
        $this.innerText = "copy";
      }, 1500);
    }

// 购物车订单备注
jQuery(function(){
  jQuery('.cart-right .note .icon').on('click', function(){
      jQuery('textarea#CartNote').toggle();
  });
})
        

